import { useQuery } from '@apollo/client';
import { getBuyTogetherProducts } from '@catalogo/service-americanas-product/src/queries/combo-buy-together.graphql';

export const useBuyTogether = (firstId: string, secondId: string) => {
  const { loading, data, error } = useQuery(getBuyTogetherProducts, {
    variables: {
      firstId,
      secondId,
    },
    skip: !(firstId && secondId),
    ssr: false,
  });

  return { loading, data, error };
};
